import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import InnerHTML from 'dangerously-set-html-content';

function StatusTemplate({ template }) {
    useEffect(() => {
        const iframeElem = document.getElementById("wpg-iframe");
        const statusElem = document.getElementById("wps-payment-status-message");
        const iframeParent = document.querySelector(".iframe-parent");
        // Clear text content of all elements inside iframeParent except wpg-iframe and wps-payment-status-message (and its descendants), keep elements
        if (iframeParent) {
            Array.from(iframeParent.querySelectorAll('*')).forEach(node => {
                // Skip wpg-iframe, wps-payment-status-message, and descendants of wps-payment-status-message
                if (
                    node !== iframeElem &&
                    node !== statusElem &&
                    !(statusElem && statusElem.contains(node))
                ) {
                    // Remove only text nodes from this element
                    Array.from(node.childNodes).forEach(child => {
                        if (child.nodeType === Node.TEXT_NODE) {
                            child.textContent = '';
                        }
                    });
                }
            });
        }
        // Only render status message if not present
        if (!statusElem) {
            ReactDOM.render(
                <div id='wps-payment-status-message'><p>Your payment session is no longer active. You may have already completed your purchase. Please go to your My Account to check your purchased order.</p></div>,
                iframeElem
            );
        }
        else {
            statusElem.style.display = 'block';
        }
    }, [template]);

    return (
        <div>
            {template ?
                (<div><InnerHTML html={template} /></div>) : (<div id="wpg-iframe"></div>)}
        </div>
    )
}

export default StatusTemplate;